// generate a cheap UUID v4 without crypto
// (for environments that don't support it, which should be rare)
// @see https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts
export const createUUID = (): string => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()

  const random = () => Math.floor(Math.random() * 16).toString(16)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, (c) => {
      const r = random()
      const v = c === 'x' ? r : (parseInt(r, 16) & 0x3) | 0x8
      return v.toString(16)
    })
    .toUpperCase()
}

export const createExtrnId = (): string => {
  return `${Date.now()}-${createUUID().slice(0, 8)}`
}
